module.exports = __webpack_public_path__ + "static/img/case5.601087ef.jpg";